<template>
  <div>
    <v-row no-gutters>
      <v-btn style="z-index: 100000" absolute top right icon color="red" @click="openCancelConfirm()">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-col cols="auto">
        <v-avatar size="80">
          <v-img cover :src="getImageForExercise(exercise)" position="top center"></v-img>
        </v-avatar>
      </v-col>

      <v-col class="align-center">
        <v-card-title class="pb-0">{{ exercise.title }}</v-card-title>
        <!-- Je nach Modus wird entweder die Technikinfo oder das automatisch analysierte Schema angezeigt -->
        <template v-if="selectedTechniqueMode !== 'normal' && techniqueInfo">
          <v-tooltip bottom style="opacity: 1">
            <template v-slot:activator="{ on }">
              <div v-on="on" style="display: inline-block">
                <v-chip class="ml-3" :color="techniqueInfo.color" small>
                  <v-icon small left>{{ techniqueInfo.icon }}</v-icon
                  >{{ techniqueInfo.descriptionShort }}
                </v-chip>
              </div>
            </template>
            <span>{{ techniqueInfo.description }}</span>
          </v-tooltip>
        </template>
        <template v-else-if="analyzeExercise && analyzeExercise.text">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-show="analyzeExercise && analyzeExercise.color" style="display: inline-block">
                <v-chip v-on="on" class="ml-3" :color="analyzeExercise.color" small>
                  {{ analyzeExercise.text }}
                </v-chip>
              </div>
            </template>
            <span>{{ analyzeExercise.description }}</span>
          </v-tooltip>
        </template>
      </v-col>

      <v-col cols="12">
        <v-divider color="white"></v-divider>
      </v-col>

      <v-col cols="12" v-if="exercise.general_exercise_settings.length">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-card-title class="px-1 py-1 font-weight-bold">Geräteeinstellungen</v-card-title>
          </v-col>
          <v-col class="align-content-center" v-if="savedGeneralExerciseSettings" cols="grow">
            <v-btn class="ma-1" x-small fab color="blue" @click="savedGeneralExerciseSettings = false">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-chip
              color="grey"
              class="mr-2"
              v-for="(setting, index) in exercise.general_exercise_settings.filter((setting) => setting.value)"
              :key="'setting' + index">
              <span>{{ shorten(setting.text) + " | " + setting.value }}</span>
            </v-chip>
          </v-col>
        </v-row>
        <v-expand-transition mode="out-in" v-if="!savedGeneralExerciseSettings">
          <v-row no-gutters>
            <v-col
              cols="auto"
              class="pa-1 d-flex align-center fill-height"
              :key="index + 'deviceSetting'"
              v-for="(deviceSetting, index) in exercise.general_exercise_settings">
              <v-card
                class="d-flex flex-column align-center justify-space-between"
                elevation="2"
                style="width: auto; min-width: 0px; max-width: none; transition: width 0.3s">
                <span class="truncate py-1 px-2 font-weight-bold">
                  {{ shorten(deviceSetting.text, 10) }}
                </span>
                <div class="input-wrapper pb-1">
                  <v-select
                    dense
                    solo
                    height="20px"
                    style="line-height: 1"
                    hide-details
                    class="pa-0 ma-0"
                    v-model="deviceSetting.value"
                    :items="deviceSetting.selections"
                    v-if="deviceSetting && deviceSetting.input === 'selection'"
                    @keydown.enter.prevent="closeSettingDialog()"></v-select>
                  <span
                    v-else
                    contenteditable="true"
                    :class="{ 'text-center': !deviceSetting.value || true }"
                    @input="updatingSetting($event, deviceSetting)"
                    :type="deviceSetting.input"
                    placeholder="+"
                    class="compact-input flex-grow-1 pb-2"
                    v-text="deviceSetting.value"></span>
                </div>
              </v-card>
            </v-col>
            <v-col cols="auto" class="ml-2 align-content-center">
              <v-btn x-small fab color="primary" @click="saveGeneralExerciseSettings()">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-divider color="white"></v-divider>
      </v-col>
      <v-col cols="12">
        <v-expand-transition>
          <v-row no-gutters v-if="combinedExerciseSets">
            <v-col class="mb-2" :key="'exerciseSet' + index" cols="auto" v-for="(set, index) in combinedExerciseSets">
              <v-slide-x-transition>
                <v-card class="fill-height rounded-xl mr-2">
                  <v-row no-gutters>
                    <v-col cols="grow" class="flex-grow">
                      <v-card-title class="font-weight-bold py-1 orange--text" v-if="exercise.warmup && index === 0">
                        <v-icon color="orange">mdi-fire</v-icon> Aufwärmsatz
                      </v-card-title>
                      <v-card-title v-else class="font-weight-bold py-1">{{ "Satz " + (exercise.warmup ? index : index + 1) }}</v-card-title>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn class="ma-1" v-if="exercise.warmup && index === 0" small icon color="red" @click="removeWarmupSet()">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-btn class="ma-1" v-else small icon color="white" @click="editSet(index)">
                        <v-icon>mdi-circle-edit-outline</v-icon>
                      </v-btn>
                      <!-- 
                      <v-btn class="ma-1" small icon :color="exercise.warmup && index === 0 ? 'red' : 'red'" @click="removeSetByIndex(index)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      -->
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-chip
                        class="my-2 mx-1"
                        small
                        :key="'setsetting' + index"
                        v-for="(setting, index) in set.filter((setting) => setting.value && setting.text !== 'Notiz')">
                        <span>{{ shorten(setting.text) + " | " + getSettingText(setting) }}</span>
                      </v-chip>
                      <br />
                      <span class="px-2 pb-1" v-if="set.find((setting) => setting.text === 'Notiz' && setting.value)">
                        {{ "Notiz: " + set.find((setting) => setting.text === "Notiz").value }}
                      </span>
                    </v-col>
                  </v-row>
                </v-card>
              </v-slide-x-transition>
            </v-col>
          </v-row>
        </v-expand-transition>
      </v-col>
      <!-- Auswahlbereich: wird nur angezeigt, solange noch keine Sätze erstellt wurden -->
      <v-row no-gutters v-if="!exercise.sets.length">
        <v-col cols="12">
          <v-item-group v-model="selectedTechniqueMode" mandatory class="technique-card-group">
            <v-row no-gutters>
              <v-col cols="auto" v-for="mode in techniqueModes" :key="mode.value" class="pa-1">
                <v-item :disabled="exercise.warmup && mode.value === 'warmup'" :value="mode.value" v-slot="{ active, toggle }">
                  <v-card
                    class="rounded-lg"
                    :class="[{ 'technique-custom-card--active': active }, 'technique-custom-card']"
                    outlined
                    tile
                    @click="toggle">
                    <v-card-text class="d-flex flex-column align-center pa-2">
                      <v-icon style="z-index: 1">{{ mode.icon }}</v-icon>
                      <div :style="{ 'color: white': active }" style="z-index: 1" class="mt-2 text-center">{{ mode.text }}</div>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
              <span ref="highlight" class="highlight"></span>
            </v-row>
          </v-item-group>
        </v-col>

        <!-- Parameterfelder für Intensitätstechniken (wenn nicht 'Normale Sätze') -->
        <template v-if="selectedTechniqueMode !== 'normal'">
          <!-- Für Dropset -->
          <v-col class="mt-2" cols="12" v-if="selectedTechniqueMode === 'dropset'">
            <v-row no-gutters>
              <v-col cols="5">
                <v-text-field
                  hide-details
                  filled
                  class="mr-2"
                  v-model="techniqueDropset.maxWeight"
                  label="Maximales Gewicht (Dropset)"
                  type="number"
                  :rules="[validateWeight]"
                  suffix="KG">
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-checkbox hide-details filled v-model="allowArbitraryWeight" label="Beliebiges Gewicht zulassen" color="primary"> </v-checkbox>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field hide-details class="mr-2" filled v-model="techniqueDropset.setCount" label="Anzahl Sätze" type="number"> </v-text-field>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field hide-details class="mr-2" filled v-model="techniqueDropset.minReps" label="Min Wiederholungen" type="number">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field hide-details class="mr-2" filled v-model="techniqueDropset.maxReps" label="Max Wiederholungen" type="number">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field
                  hide-details
                  class="mr-2"
                  filled
                  v-model="techniqueDropset.reductionPercentage"
                  label="Gewichtsreduktion (%)"
                  type="number">
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <!-- Für Reverse Dropset -->
          <v-col class="mt-2" cols="12" v-if="selectedTechniqueMode === 'reversedropset'">
            <v-row no-gutters>
              <v-col cols="5">
                <v-text-field
                  filled
                  hide-details
                  class="mr-2"
                  v-model="techniqueReverseDropset.maxWeight"
                  label="Maximales Gewicht (Reverse Dropset)"
                  type="number"
                  :rules="[validateWeight]"
                  suffix="KG">
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-checkbox hide-details filled v-model="allowArbitraryWeight" label="Beliebiges Gewicht zulassen" color="primary"> </v-checkbox>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field hide-details class="mr-2" filled v-model="techniqueReverseDropset.setCount" label="Anzahl Sätze" type="number">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field hide-details filled v-model="techniqueReverseDropset.minReps" label="Min Wiederholungen" type="number"> </v-text-field>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field hide-details class="mr-2" filled v-model="techniqueReverseDropset.maxReps" label="Max Wiederholungen" type="number">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field hide-details filled v-model="techniqueReverseDropset.reductionPercentage" label="Gewichtserhöhung (%)" type="number">
                </v-text-field>
              </v-col>
              <!-- Hier wird "Gewichtserhöhung (%)" als Label angezeigt -->
            </v-row>
          </v-col>

          <!-- Für Schockwellen-Sätze -->
          <v-col class="mt-2" cols="12" v-if="selectedTechniqueMode === 'schockwelle'">
            <v-row no-gutters>
              <v-col cols="5">
                <v-text-field
                  filled
                  hide-details
                  class="mr-2"
                  v-model="techniqueSchockwelle.startWeight"
                  label="Startgewicht (Schockwellen)"
                  type="number"
                  :rules="[validateWeight]"
                  suffix="KG">
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-checkbox hide-details v-model="allowArbitraryWeight" label="Beliebiges Gewicht zulassen" color="primary"> </v-checkbox>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field
                  class="mr-2"
                  hide-details
                  filled
                  v-model="techniqueSchockwelle.incrementPercentage"
                  label="Gewichtszuwachs (%)"
                  type="number">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field hide-details filled v-model="techniqueSchockwelle.pause" label="Pausenzeit (Sek.)" type="number"> </v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <!-- Für FST-7 -->
          <v-col class="mt-2" cols="12" v-if="selectedTechniqueMode === 'fst7'">
            <v-row no-gutters>
              <v-col cols="5">
                <v-text-field
                  hide-details
                  filled
                  v-model="techniqueFst7.weight"
                  label="Gewicht (FST-7)"
                  type="number"
                  :rules="[validateWeight]"
                  suffix="KG">
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-checkbox hide-details filled v-model="allowArbitraryWeight" label="Beliebiges Gewicht zulassen" color="primary"> </v-checkbox>
              </v-col>
              <v-col cols="12" md="5" class="mt-2">
                <v-text-field hide-details filled v-model="techniqueFst7.pause" label="Pausenzeit (Sek.)" type="number"> </v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </template>
      </v-row>
      <v-col
        cols="10"
        class="justify-content-center text-center mt-3"
        v-if="selectedTechniqueMode !== 'normal' && selectedTechniqueMode !== 'warmup' && !exercise.sets.length">
        <v-btn color="primary" @click="generateSetsForTechnique"> Sätze generieren </v-btn>
      </v-col>
      <!-- Manuelle Eingabe: Nur sichtbar, wenn "Normale Sätze" gewählt -->
      <v-expand-transition v-if="selectedTechniqueMode === 'normal' || selectedTechniqueMode === 'warmup'">
        <v-col cols="12">
          <v-card-title class="px-1 py-1 mt-2 font-weight-bold">
            {{
              editingSetIndex !== null
                ? "Satz " + (exercise.warmup ? editingSetIndex + 1 : editingSetIndex + 1) + " bearbeiten"
                : exercise.sets.length
                ? "Satz " + (exercise.sets.length + 1) + " hinzufügen"
                : selectedTechniqueMode === "warmup"
                ? "Aufwärmsatz hinzufügen"
                : "Ersten Satz hinzufügen"
            }}
          </v-card-title>
          <v-row no-gutters>
            <v-col
              cols="auto"
              class="pa-1 d-flex align-center fill-height"
              :key="index + 'deviceSetting'"
              v-for="(setSetting, index) in exercise.set_exercise_settings">
              <v-card color="" class="d-flex flex-column align-center justify-space-between" elevation="2">
                <span class="truncate py-1 px-2 font-weight-bold">
                  {{ shorten(setSetting.text, 10) }}
                </span>
                <div class="input-wrapper pb-1">
                  <v-select
                    dense
                    solo
                    height="20px"
                    style="line-height: 1"
                    hide-details
                    class="pa-0 ma-0"
                    v-model="setSetting.value"
                    :items="setSetting.selections"
                    v-if="setSetting && setSetting.input === 'selection'"
                    @keydown.enter.prevent="closeSettingDialog()">
                  </v-select>
                  <span
                    v-else
                    contenteditable="true"
                    :class="{ 'text-center': !setSetting.value || true }"
                    :type="setSetting.input"
                    placeholder="+"
                    class="compact-input flex-grow-1 pb-2"
                    v-text="setSetting.value"
                    @input="updatingSetting($event, setSetting)">
                  </span>
                </div>
              </v-card>
            </v-col>
            <v-col cols="auto" class="ml-2 align-content-center">
              <v-btn small fab color="primary" @click="saveSet">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn v-if="editingSetIndex !== null" class="ml-2" small fab color="grey" @click="cancelEditSet">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn v-if="editingSetIndex !== null" class="ml-2" small fab color="red" @click="removeSetByIndex(editingSetIndex)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-expand-transition>

      <!-- Anzeige der erstellten Sätze -->

      <v-col cols="12" v-if="!isButtonDisabled">
        <v-card-actions class="justify-content-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on" style="display: inline-block">
                <v-btn class="rounded-xl" :class="{ 'disabled-button': isButtonDisabled }" color="primary" @click="onButtonClick">
                  Änderungen speichern
                </v-btn>
              </div>
            </template>
            <span>{{ tooltipMessage }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from "@/api"
import { mapActions, mapGetters } from "vuex"

export default {
  name: "WorkoutAddExercise",
  props: {
    exerciseProp: {
      type: Object,
    },
    trainingMethods: {
      type: Object,
    },
  },
  data() {
    return {
      exercise: {
        method: "",
        warmup: null,
      },
      savedGeneralExerciseSettings: false,
      editingSetIndex: null,
      selectedTechniqueMode: "normal",
      techniqueModes: [
        { text: "Aufwärmen", value: "warmup", icon: "mdi-fire" },
        { text: "Normale Sätze", value: "normal", icon: "mdi-format-list-bulleted" },
        { text: "Dropset", value: "dropset", icon: "mdi-trending-down" },
        { text: "Reverse Dropset", value: "reversedropset", icon: "mdi-trending-up" },
        { text: "Schockwellen-Sätze", value: "schockwelle", icon: "mdi-lightning-bolt" },
        { text: "FST-7", value: "fst7", icon: "mdi-weight-lifter" },
      ],
      allowArbitraryWeight: false,
      techniqueDropset: {
        maxWeight: null,
        setCount: 3,
        minReps: 8,
        maxReps: 12,
        reductionPercentage: 20, // in Prozent
      },
      // Parameter für Reverse Dropset (ähnlich wie Dropset, jedoch mit umgekehrter Gewichtsdifferenzierung)
      techniqueReverseDropset: {
        maxWeight: null,
        setCount: 3,
        minReps: 8,
        maxReps: 12,
        reductionPercentage: 20, // in Prozent, wird als Erhöhung interpretiert
      },
      // Parameter für Schockwellen-Sätze
      techniqueSchockwelle: {
        startWeight: null,
        incrementPercentage: 10, // z. B. 10% Zuwachs pro Satz
        pause: 30, // in Sekunden
        setCount: 5,
        reps: 4,
      },
      // Parameter für FST-7
      techniqueFst7: {
        weight: null,
        pause: 30, // in Sekunden
        setCount: 7,
        reps: 7,
      },
    }
  },
  computed: {
    combinedExerciseSets() {
      let combined = JSON.parse(JSON.stringify(this.exercise.sets)) || []
      if (this.exercise.warmup) combined.unshift(this.exercise.warmup)
      console.log(this.exercise.warmup, "da ischs warmup")
      return combined
    },
    // Falls "Normale Sätze" nicht gewählt sind, liefert diese Computed Property ein Objekt mit Symbol, Kurzbeschreibung und detaillierter Beschreibung.
    techniqueInfo() {
      if (this.selectedTechniqueMode === "normal" || this.selectedTechniqueMode === "warmup") return null
      const mapping = {
        dropset: {
          icon: "mdi-trending-down",
          descriptionShort: "Dropset",
          description:
            "Ein Dropset ist eine Trainingsmethode, bei der nach Erreichen der muskulären Erschöpfung eines Satzes das Gewicht reduziert wird, sodass derselbe Satz ohne Pause fortgesetzt werden kann. Dadurch wird der Muskel über seine übliche Belastungsgrenze hinaus weiter beansprucht, was zu einer intensiveren Ermüdung und potenziell zu einem gesteigerten Muskelwachstum führt.",
          color: "primary",
        },
        reversedropset: {
          icon: "mdi-trending-up",
          descriptionShort: "Reverse Dropset",
          description:
            "Ein Reverse-Dropset ist eine Trainingsmethode, bei der mit leichterem Gewicht begonnen und das Gewicht im Verlauf des Satzes nach und nach erhöht wird. Dies steht im Gegensatz zu traditionellen Dropsets, bei denen das Gewicht verringert wird, nachdem der Muskelversagen erreicht hat. Manchmal wird es auch als 'aufsteigendes Dropset' bezeichnet, da das Gewicht während des Satzes steigt, während die Wiederholungen im Gegenteil sinken.",
          color: "primary",
        },
        schockwelle: {
          icon: "mdi-lightning-bolt",
          descriptionShort: "Schockwellen-Sätze",
          description:
            "Schockwellen-Sätze: 5 Sätze à 4 Wiederholungen, bei denen das Gewicht pro Satz erhöht wird. Standardpause 30 Sek. Passe Startgewicht und Zuwachs an, um die Intensität zu variieren.",
          color: "orange",
        },
        fst7: {
          icon: "mdi-weight-lifter",
          descriptionShort: "FST-7",
          description: "FST-7 (Fascia Stretch Training): 7 Sätze à 7 Wiederholungen zur Maximierung des Muskelpumps.",
          color: "primary",
        },
      }
      return mapping[this.selectedTechniqueMode] || null
    },
    analyzeExercise() {
      const sets = this.exercise.sets
      let method = ""
      if (!sets || sets.length < 3) return

      const weights = sets.map((set) => this.getSettingValue(set, "Gewicht"))
      const pauses = sets.map((set) => this.getSettingValue(set, "Pause"))
      const repetitions = sets.map((set) => this.getSettingValue(set, "Max Wiederholungen") || this.getSettingValue(set, "Min Wiederholungen"))

      const isDescendingWeight = weights.every((w, i, arr) => !i || w < arr[i - 1])
      const isAscendingWeight = weights.every((w, i, arr) => !i || w > arr[i - 1])
      const hasPauses = pauses.length && pauses.some((p) => p > 0)

      if (isDescendingWeight && !hasPauses) {
        this.$set(this.exercise, "method", "dropSet")
        method = "dropSet"
      } else if (isAscendingWeight && !hasPauses) {
        this.$set(this.exercise, "method", "reverseDropSet")
        method = "reverseDropSet"
      } else if ((isAscendingWeight || isDescendingWeight) && hasPauses) {
        this.$set(this.exercise, "method", "pyramidSet")
        method = "pyramidSet"
      } else if (hasPauses) {
        this.$set(this.exercise, "method", "restPause")
        method = "restPause"
      } else {
        this.exercise.method = ""
      }

      return this.trainingMethods[method] || {}
    },
    isButtonDisabled() {
      return !this.exercise.sets.length
    },
    tooltipMessage() {
      const messages = []
      if (!this.exercise.sets.length) {
        messages.push("Mindestens einen Satz hinzufügen")
      }
      return messages.join(" ")
    },
  },
  watch: {
    selectedTechniqueMode(newValue) {
      this.updateHighlight(this.techniqueModes.findIndex((mode) => mode.value === newValue))
    },
  },
  async created() {
    this.exercise = JSON.parse(JSON.stringify(this.exerciseProp))
    this.$set(this.exercise, "method", "")
    if (!this.exercise.warmup) this.$set(this.exercise, "warmup", null)
    if (!this.exercise.sets) this.$set(this.exercise, "sets", [])
  },
  mounted() {
    this.updateHighlight(1)
  },
  methods: {
    ...mapActions("deviceStore", ["setDeviceList"]),
    removeWarmupSet() {
      if (confirm("Aufwärmsatz entfernen?")) {
        this.exercise.warmup = null
        this.editingSetIndex = null
      }
    },
    updateHighlight(index) {
      const btns = this.$el.querySelectorAll(".technique-custom-card")
      const highlight = this.$refs.highlight
      if (!btns.length) return
      const selectedBtn = btns[index]

      highlight.style.width = Number(selectedBtn.offsetWidth) + 4 + "px"
      highlight.style.height = Number(selectedBtn.offsetHeight) + 4 + "px"
      highlight.style.left = selectedBtn.parentElement.offsetLeft + "px"
      highlight.style.top = selectedBtn.parentElement.offsetTop + "px"
    },
    editSet(index) {
      if (this.exercise.warmup && index === 0) {
        this.editingSetIndex = null
        this.exercise.set_exercise_settings = JSON.parse(JSON.stringify(this.exercise.warmup))
        return
      }
      if (this.exercise.warmup) {
        index = index - 1
      }
      this.editingSetIndex = index
      console.log(this.exercise.sets[index])
      this.exercise.set_exercise_settings = JSON.parse(JSON.stringify(this.exercise.sets[index]))
    },
    getSettingValue(set, settingText) {
      const setting = set.find((s) => s.text === settingText)
      return setting ? parseFloat(setting.value) || setting.value : null
    },
    onButtonClick() {
      if (!this.isButtonDisabled) {
        let weights = this.exercise.sets.map((set) => parseFloat(set.find((item) => item.text === "Gewicht").value))
        let minReps = this.exercise.sets.map((set) => parseInt(set.find((item) => item.text === "Min Wiederholungen").value))
        let maxReps = this.exercise.sets.map((set) => parseInt(set.find((item) => item.text === "Max Wiederholungen").value))
        this.exercise.weightSum = { min: Math.min(...weights), max: Math.max(...weights) }
        this.exercise.repSum = { min: Math.min(...minReps), max: Math.max(...maxReps) }
        this.$emit("savedExercise", this.exercise)
      }
    },
    removeSetByIndex(index) {
      this.exercise.sets.splice(index, 1)
      this.editingSetIndex = null

      if (this.exercise.sets.length)
        this.exercise.set_exercise_settings = JSON.parse(JSON.stringify(this.exercise.sets[this.exercise.sets.length - 1]))
    },
    saveGeneralExerciseSettings() {
      if (!this.exercise.general_exercise_settings.find((setting) => setting.value)) {
        if (confirm("Ohne Geräteeinstellungen fortfahren?")) {
          this.savedGeneralExerciseSettings = true
        }
      } else {
        this.savedGeneralExerciseSettings = true
      }
    },
    saveSet() {
      if (this.exercise.set_exercise_settings.find((setting) => setting.value)) {
        const newSet = JSON.parse(JSON.stringify(this.exercise.set_exercise_settings))

        if (this.selectedTechniqueMode === "warmup") {
          this.$set(this.exercise, "warmup", newSet)
          console.log(newSet)
          this.selectedTechniqueMode = "normal"
          return
        }
        if (this.editingSetIndex !== null) {
          this.exercise.sets.splice(this.editingSetIndex, 1, newSet)
          this.editingSetIndex = null
        } else {
          console.log("er pusht etz", newSet)
          this.exercise.sets.push(newSet)
        }
      } else {
        alert("Füge mindestens eine Satzeinstellung hinzu")
      }
    },
    cancelEditSet() {
      this.editingSetIndex = null
      this.exercise.set_exercise_settings = JSON.parse(JSON.stringify(this.exercise.sets[this.exercise.sets.length - 1]))
    },
    openCancelConfirm() {
      if (this.exercise.sets.length || this.savedGeneralExerciseSettings) {
        if (confirm("ungespeicherte Änderungen gehen verloren")) return this.$emit("cancel-edit")
      } else {
        this.$emit("cancel-edit")
      }
    },
    updatingSetting(event, item) {
      item.value = event.target.innerText.trim()
    },
    getImageForExercise(exercise) {
      if (exercise.picture) return this.getImageUrl(exercise.picture)
      if (exercise.manual && exercise.manual[0] && exercise.manual[0].picture) return this.getImageUrl(exercise.manual[0].picture)
      return "/img/uebungen/einmalig/imageUploadPlaceholder.jpg"
    },
    getImageUrl(image) {
      return "/img/uebungen/" + image.replace(/\.[^/.]+$/, "") + ".webp"
    },
    shorten(text, length = 25) {
      if (text === "Min Wiederholungen") return "Min WH"
      if (text === "Max Wiederholungen") return "Max WH"
      if (text === "Umdrehungen pro Minute") return "UPM"
      if (text.length > length) text = text.substr(0, length) + "..."
      return text
    },
    getSettingText(setting) {
      let text = setting.value
      if (setting.text === "Gewicht") text = text + " KG"
      if (setting.text === "Dauer") text = text + ""
      return text
    },
    // Validierung: Gewicht muss – sofern nicht beliebig erlaubt – ein Vielfaches von 5 sein
    validateWeight(value) {
      if (this.allowArbitraryWeight) return true
      return value % 5 === 0 || "Das Gewicht muss ein Vielfaches von 5 sein."
    },
    // Automatische Erzeugung der Sätze je nach gewählter Intensitätstechnik
    generateSetsForTechnique() {
      if (this.selectedTechniqueMode === "dropset") {
        if (!this.techniqueDropset.maxWeight) {
          alert("Bitte geben Sie das maximale Gewicht für Dropset ein.")
          return
        }
        let maxWeight = parseFloat(this.techniqueDropset.maxWeight)
        if (!this.allowArbitraryWeight && maxWeight % 5 !== 0) {
          alert("Im Standardmodus muss das Gewicht ein Vielfaches von 5 sein.")
          return
        }
        let setCount = parseInt(this.techniqueDropset.setCount) || 3
        let reductionPerc = parseFloat(this.techniqueDropset.reductionPercentage) / 100
        this.exercise.sets = []
        for (let i = 0; i < setCount; i++) {
          let calculatedWeight = maxWeight * Math.pow(1 - reductionPerc, i)
          if (!this.allowArbitraryWeight) {
            calculatedWeight = Math.floor(calculatedWeight / 5) * 5
          } else {
            calculatedWeight = parseFloat(calculatedWeight.toFixed(2))
          }
          const newSet = [
            { text: "Gewicht", value: calculatedWeight },
            { text: "Min Wiederholungen", value: this.techniqueDropset.minReps },
            { text: "Max Wiederholungen", value: this.techniqueDropset.maxReps },
            // Keine Pause
          ]
          this.exercise.sets.push(newSet)
        }
        this.exercise.method = "dropset"
      } else if (this.selectedTechniqueMode === "reversedropset") {
        if (!this.techniqueReverseDropset.maxWeight) {
          alert("Bitte geben Sie das maximale Gewicht für Reverse Dropset ein.")
          return
        }
        let maxWeight = parseFloat(this.techniqueReverseDropset.maxWeight)
        if (!this.allowArbitraryWeight && maxWeight % 5 !== 0) {
          alert("Im Standardmodus muss das Gewicht ein Vielfaches von 5 sein.")
          return
        }
        let setCount = parseInt(this.techniqueReverseDropset.setCount) || 3
        let reductionPerc = parseFloat(this.techniqueReverseDropset.reductionPercentage) / 100
        this.exercise.sets = []
        // Beim Reverse Dropset werden die Sätze in umgekehrter Reihenfolge erzeugt:
        for (let i = 0; i < setCount; i++) {
          let calculatedWeight = maxWeight * Math.pow(1 - reductionPerc, setCount - 1 - i)
          if (!this.allowArbitraryWeight) {
            calculatedWeight = Math.floor(calculatedWeight / 5) * 5
          } else {
            calculatedWeight = parseFloat(calculatedWeight.toFixed(2))
          }
          const newSet = [
            { text: "Gewicht", value: calculatedWeight },
            { text: "Min Wiederholungen", value: this.techniqueReverseDropset.minReps },
            { text: "Max Wiederholungen", value: this.techniqueReverseDropset.maxReps },
            // Keine Pause
          ]
          this.exercise.sets.push(newSet)
        }
        this.exercise.method = "reversedropset"
      } else if (this.selectedTechniqueMode === "schockwelle") {
        if (!this.techniqueSchockwelle.startWeight) {
          alert("Bitte geben Sie das Startgewicht für Schockwellen-Sätze ein.")
          return
        }
        let startWeight = parseFloat(this.techniqueSchockwelle.startWeight)
        if (!this.allowArbitraryWeight && startWeight % 5 !== 0) {
          alert("Im Standardmodus muss das Gewicht ein Vielfaches von 5 sein.")
          return
        }
        let setCount = this.techniqueSchockwelle.setCount
        let incrementPerc = parseFloat(this.techniqueSchockwelle.incrementPercentage) / 100
        this.exercise.sets = []
        for (let i = 0; i < setCount; i++) {
          let calculatedWeight = startWeight * (1 + i * incrementPerc)
          if (!this.allowArbitraryWeight) {
            calculatedWeight = Math.floor(calculatedWeight / 5) * 5
          } else {
            calculatedWeight = parseFloat(calculatedWeight.toFixed(2))
          }
          const newSet = [
            { text: "Gewicht", value: calculatedWeight },
            { text: "Min Wiederholungen", value: this.techniqueSchockwelle.reps },
            { text: "Max Wiederholungen", value: this.techniqueSchockwelle.reps },
            { text: "Pause", value: this.techniqueSchockwelle.pause },
          ]
          this.exercise.sets.push(newSet)
        }
        this.exercise.method = "schockwelle"
      } else if (this.selectedTechniqueMode === "fst7") {
        if (!this.techniqueFst7.weight) {
          alert("Bitte geben Sie das Gewicht für FST-7 ein.")
          return
        }
        let weight = parseFloat(this.techniqueFst7.weight)
        if (!this.allowArbitraryWeight && weight % 5 !== 0) {
          alert("Im Standardmodus muss das Gewicht ein Vielfaches von 5 sein.")
          return
        }
        let setCount = this.techniqueFst7.setCount
        this.exercise.sets = []
        for (let i = 0; i < setCount; i++) {
          let setWeight = weight
          if (!this.allowArbitraryWeight) {
            setWeight = Math.floor(setWeight / 5) * 5
          } else {
            setWeight = parseFloat(setWeight.toFixed(2))
          }
          const newSet = [
            { text: "Gewicht", value: setWeight },
            { text: "Min Wiederholungen", value: this.techniqueFst7.reps },
            { text: "Max Wiederholungen", value: this.techniqueFst7.reps },
            { text: "Pause", value: this.techniqueFst7.pause },
          ]
          this.exercise.sets.push(newSet)
        }
        this.exercise.method = "fst7"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.compact-input {
  width: auto;
  min-width: 50px;
  border: none;
  background: transparent;
  padding: 5px;
  font-size: 14px;
  transition: width 0.3s, border-color 0.3s;
  outline: none;
}

.compact-input:empty:before {
  content: "+";
  color: white;
}

.compact-input:focus:empty:before {
  border: 1px solid white;
}

.input-wrapper {
  flex-grow: 1;
  height: 38px;
}

.v-card {
  transition: width 0.3s, box-shadow 0.3s;
}

.v-card:hover {
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.disabled-button {
  opacity: 0.5;
  pointer-events: none;
}

.technique-custom-card {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  border-radius: 8px;
  color: #d7d7d7;
}
.highlight {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: var(--v-primary);
  border-radius: 8px;
  transition: all 0.3s ease;
}
</style>
